import PopupSubmit from './PopupSubmit';

export default PopupSubmit;
